import React from 'react';
import * as antdIcons from '@ant-design/icons';

/**
 * A map to dynamically retrieve Ant Design icon components based on a string name.
 * The backend sends icon names (e.g., "UserOutlined"), and this map provides
 * the corresponding React component.
 */
const iconMap = {
    ...antdIcons,
    JigsawIcon: antdIcons.TeamOutlined, // Handle alias from original data file
};

/**
 * A helper function to get an icon component from the map.
 * @param {string} iconName - The name of the icon (e.g., "BookOutlined").
 * @returns {React.Component} The icon component or a default if not found.
 */
export const getIcon = (iconName) => {
    const IconComponent = iconMap[iconName];
    return IconComponent ? <IconComponent /> : <antdIcons.QuestionCircleOutlined />;
};
